const setResumeWork = (work) => ({
    type: 'SET_RESUME_WORK',
    work,
});

export default setResumeWork;
